<script>
export default {
  name: 'Practice',
  props: ['practice'],
  methods: {
    select() {
      if(this.$store.getters['dev'] || !this.practice.hPPlusSubdomain) {
        this.$store.dispatch('SET_PRACTICE', this.practice)
        this.$router.push({ name: 'Home' })
      }
      else {
        window.location.replace(`https://${ this.practice.hPPlusSubdomain }.healthypet-plus.com`)
      }
    }
  },
  computed: {
    isSelectedPractice() {
      return this.$store.state.selectedPractice && this.$store.state.selectedPractice.id == this.practice.id
    },
  },
}
</script>

<template>

  <v-row @click="select" align="center" class="practice pa-0 py-4 px-2 mx-4">
    
    <v-col class="" cols="12" md="4">
      <div class="px0">
          <p class="text-center text-md-left mb-0"><strong>{{ practice.name }}</strong></p>
          <p class="text-center text-md-left mb-0">{{ practice.address.street }}</p>
          <p class="text-center text-md-left mb-0"><span>{{ practice.address.city }}, {{ practice.address.state }}</span> {{ practice.address.zip }}</p>
      </div>
    </v-col>

    <v-col cols="12" md="4" >
      <div class="px0">
          <strong class="text-center text-md-left mb-0"><span>{{ practice.address.city }}, {{ practice.address.state }}</span> {{ practice.address.zip }}</strong>
      </div>
    </v-col>

    <v-col class="d-flex justify-center justify-md-end" cols="12" md="4">
      <div v-if="isSelectedPractice" class="pr-md-6">
        <v-icon large color="success">mdi-check-bold</v-icon>
      </div>
      <div v-else class="" style="">
        <v-btn @click="select">Select</v-btn>
      </div>
    </v-col>

  </v-row>
  
</template>

<style lang="scss" scoped>
  .practice {
    cursor: pointer;
    border-bottom: solid 1px $hpp-blue;
  }
  .practice:hover{
    background-color: $hpp-blue;
    color: white;
  }

  .underline {
    text-decoration: underline;
  }

  @media only screen and (max-width: 559px) {
    .center {
      display: flex;
      flex-direction: column;
      justify-content: center;
      margin: auto;
    }

    .center p {
      // width: 100%;
    }


  }

</style>
